import './footer.scss'

function Footer () {

    return(
        <div id='footer'>
            <p>
                Writrs © 2021 Developed by <a href='https://github.com/aysiae'>@aysiae</a> on GitHub
            </p>
        </div>
    )
}

export default Footer;